export const switchTypes = [
  { label: 'Partner Login', property: 'partnerLogin' },
  { label: 'Intern Login', property: 'internLogin' },
  { label: 'Badge', property: 'badgeLogin' }
]
